data = {};

$(document).ready(function() {
  
  localStorage.removeItem("greeting_card");
  localStorage.removeItem("greeting_message");
  localStorage.removeItem("greeting_card_HANDLE");
  localStorage.removeItem("pedido_docena");
  
  
  $('.popup-with-move-anim').magnificPopup({
    type: 'inline',

    fixedContentPos: false,
    fixedBgPos: true,

    overflowY: 'auto',

    closeBtnInside: true,
    preloader: false,

    midClick: true,
    removalDelay: 300,
    mainClass: 'my-mfp-slide-bottom'
  });

//   cargarStorageDocena();
//   cargarStorageGreetingCard();
//   cargarStorageMessage();
//   $("#d_sum").val(sumarPedido_docena());

//   jQuery.post('/cart/change.js', { quantity: 0, id: 32727203807277 });


  if(screen.width<=800){
    $(".small-dialog").removeClass("clase_modal_1");

    $(".small-dialog").addClass("clase_modal_2");
  }


});





$("#btn_add_cart").click( function() {
  var cantidad_doce=parseInt(sumarPedido_docena());
  var data_greeting_card=localStorage.getItem("greeting_card");
  var data_greeting_message=localStorage.getItem("greeting_message");

  if(!cantidad_doce || cantidad_doce<12){
    Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: 'You must choose a dozen donuts !'
    });
    return;
  }

  if(!data_greeting_card || data_greeting_card==""){
    Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: 'You must choose a Greeting card !'
    });
    return;
  }

  if(!data_greeting_message || data_greeting_message==""){
    Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: 'You must choose a Greeting message !'
    });
    return;
  }

  var properties = {};

  var donuts = '';
  $('input.donut:visible').each(function(){
    if( $(this).val() > 0 ) {
      donuts += ' | ' + $(this).attr('data-title') + ' x ' + $(this).val();
    }
  });
  properties.donuts = donuts;
  properties.card = localStorage.getItem("greeting_card_HANDLE");
  //properties.datetime = $('#date_time').val().replace("T", " ");
  properties.message = data_greeting_message;

  $.post( "/cart/add.js", {items: [{quantity: 1,id: 32727203807277,properties: properties}]}, function( data ) {
    localStorage.removeItem("greeting_card");
    localStorage.removeItem("greeting_message");
    localStorage.removeItem("greeting_card_HANDLE");
    localStorage.removeItem("pedido_docena");
    window.location.href = "/cart";
  }, "json");

});



$(".cerrar_modal").click(function()
                         {
  $(".small-dialog").hide();   

});

$(".img_product").click(function()
                        {

  if(screen.width<=800){
    $(".small-dialog").removeClass("clase_modal_1");

    $(".small-dialog").addClass("clase_modal_2");

    var hand=$(this).val();

    $(".small-dialog").hide();
    $("#modal-"+hand).show();

  }else{

    $(".small-dialog").removeClass("clase_modal_2");

    $(".small-dialog").addClass("clase_modal_1");

    var hand=$(this).val();

    $(".small-dialog").hide();
    console.log("-----------------")
    console.log(hand)
    $("#modal-"+hand).show();
  }


});

$("#btn_set_message").click(function()
                            {
  var datext=$("#text_message").val();

  guardarStorageMessage(datext);

  Swal.fire({
    icon: 'success',
    text: 'The message has been saved correctly.'
  });
  return;
});


function cambio_n(r,handle)
{
  var $this = $('.' + r + ':visible');
  var valor_now=$this.val();
  var valor_anti=buscar_valor(r).cantidad;

  if(!valor_now)
  {
    $this.val(0);
    cargarStorageDocena();

    Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: 'You need to choose a value!'
    });
    return;
  }

  if(valor_now<0)
  {
    $this.val(0);
    cargarStorageDocena();

    Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: 'You cannot choose a value less than 0!'
    });
    return;
  }

  if(!valor_anti){
    valor_anti=0;
  }


  suma=parseInt(valor_now)+(parseInt(sumarPedido_docena())-parseInt(valor_anti));
  if(suma>12)
  {
    $this.val(0);
    cargarStorageDocena();

    Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: 'You can only choose a dozen!'
    });
    $("#d_sum").val(sumarPedido_docena());
    return;
  }

  data[r] = {"cantidad":valor_now,"handle":''+handle};
  //donuts[handle] = valor_now;
  //     console.log("-----------------------");
  //         console.log(data);
  //         console.log("-----------------------");
  //     return;
  guardarStorageDocena(data);

  $("#d_sum").val(sumarPedido_docena());
}


function choose_greeting_card(id_gret_card,handle_gret_cart){

  guardarStorageGreetingCard(id_gret_card,handle_gret_cart);

  $(".msn_card_gret").hide();

  $("."+id_gret_card).show();


}

function cargarStorageMessage()
{
  var dataStorage=localStorage.getItem("greeting_message");

  if(dataStorage)
  {
    $('#text_message').val($('#text_message').val()+dataStorage);
    return;
  }

  return;
}

function guardarStorageMessage(msn)
{
  localStorage.setItem("greeting_message", msn);
}


function cargarStorageGreetingCard()
{
  var dataStorage=localStorage.getItem("greeting_card");

  $("."+dataStorage).show();

}

function guardarStorageGreetingCard(card,handle_gret_cart)
{
  localStorage.setItem("greeting_card", card);
  localStorage.setItem("greeting_card_HANDLE", handle_gret_cart);
}


function guardarStorageDocena(pedido_docena)
{
  localStorage.setItem("pedido_docena", JSON.stringify(pedido_docena));
}


function cargarStorageDocena()
{
  var dataStorage=localStorage.getItem("pedido_docena");
  dataStorage=JSON.parse(dataStorage);

  for(var k in dataStorage)
  {
    $("."+k).val(dataStorage[k].cantidad);

    data[k] = dataStorage[k];
  }

}

function sumarPedido_docena()
{
  var dataStorage=localStorage.getItem("pedido_docena");
  dataStorage=JSON.parse(dataStorage);
  suma=0;

  for(var k in dataStorage)
  {
    if(!$("#modal-"+dataStorage[k].handle).length){
      //console.log(dataStorage[k].handle);
      data[k] = undefined;
      guardarStorageDocena(data);
    }else{
      suma+=parseInt(dataStorage[k].cantidad);
    }
  }

  return suma;
}



function buscar_valor(id)
{
  var dataStorage=localStorage.getItem("pedido_docena");
  dataStorage=JSON.parse(dataStorage);
  suma=0;
  for(var k in dataStorage)
  {
    if(id==k)
    {
      return dataStorage[k];
    }

  }
  return 0;
}